module.exports = __webpack_public_path__ + "img/one-step.72fbcf3b.png";